import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/energy/handwritten/model/search', Object.assign({}, options, { params }));

export const getParamsNameList = (params, options) =>
  request.get('/api/v4ward/energy/handwritten/model/getEnergyMeterHandWrittenName', Object.assign({}, options, { params }));

//项目下拉框
export const getProjectList = (params, options) =>
  request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

//增加下拉框
export const getParamsData = (params, options) =>
  request.get('/api/v4ward/energy/handwritten/model/getParamsData', Object.assign({}, options, { params }));

export const viewParamData = (params, options) =>
  request.get('/api/v4ward/energy/handwritten/model/viewParamData', Object.assign({}, options, { params }));

export const saveParamData = (params, options) =>
  request.post('/api/v4ward/energy/handwritten/model/save', params,options);


